import TableFilter from 'src/components/table-filter'
import { Pagination as LPagination } from 'src/components'

export default {
  components: { TableFilter, LPagination },
  data () {
    return {
      tableFilter: '',
      pageCount: null,
      currentPage: 1,
      perPage: this.$store.state.perPage
    }
  },
  methods: {
    changePerPage (perPage) {
      this.perPage = perPage
      this.changePage(1)
    },
    changePage (page) {
      this.currentPage = page
      this.fetchTableData()
    },
    getQuery (search) {
      const searchData = search || this.tableFilter
      const queryData = {
        paginate: 1,
        search: encodeURIComponent(searchData),
        page: this.currentPage,
        per_page: this.perPage
      }
      const customQueryData = this.getCustomQueryData()
      return new URLSearchParams({ ...queryData, ...customQueryData }).toString()
    },
    fetchTableData (search) {
      return this.getData(this.getQuery(search))
    },
    getCustomQueryData () {
      return {}
    }
  }
}
